<template>
  <div>
    <div v-if="!isSushi" ref="backDiv" id="back-div" v-show="isActive" class="back-div position-absolute"></div>
<!--<div class="position-absolute bg-black top-0 w-100 h-100" >-->


    <div
      id="drawer"
      class="top-0 h-100 drawer"
      style="backgroundAttachment: 'fixed'"
      :class="{ active: isActive }"
      :style="getStyle()"
    >
      <a v-if="!isSushi" class="hamburger clearfix" @click.prevent="$emit('closed')">
        <span class="material-icons md-36">menu</span>
      </a>
      <ul class="nav flex-column clearfix"  v-if="user" :class="isSushi && 'align-content-center justify-content-center text-white text-center'">
        <li class="nav-item"  >
          <router-link class="nav-link active"  :class="isSushi && 'nav-link-sushi montserrat-700'" to="/profile">
            {{ $t("message.myAccount") }}
          </router-link>
        </li>
        <li class="nav-item" v-if="showLoyaltyOption">
          <router-link
            class="nav-link"
            :class="isSushi && 'nav-link-sushi montserrat-700'"
            :to="{
              name: useStampCollection ? 'userStamps' : 'loyalty',
              params: {
                storeid: currentStoreDoc.ID,
                storename: currentStoreDoc.Name,
              },
            }"
            >{{ $t("message.loyalty") }}</router-link
          >
        </li>
        <li class="nav-item" >
          <router-link
            class="nav-link"
            :class="isSushi && 'nav-link-sushi montserrat-700'"
            :to="{
              name: 'orderhistory',
              params: {
                storeid: currentStoreDoc.ID,
                storename: currentStoreDoc.Name,
              },
            }"
            >{{ $t("message.orderHistory") }}</router-link
          >
        </li>
        <li class="nav-item" >
          <router-link
            class="nav-link"
            :class="isSushi && 'nav-link-sushi montserrat-700'"
            :to="{
              name: 'ordertracking',
              params: {
                storeid: currentStoreDoc.ID,
                storename: currentStoreDoc.Name,
              },
            }"
            >{{ $t("message.orderTracking") }}</router-link
          >
        </li>
        <li class="nav-item"  >
          <a class="nav-link theme-link" :class="isSushi && 'nav-link-sushi montserrat-700'" href="#" @click="goToMainPage">
            {{ capitalizeFirstLetter($t("message.stores")) }}
          </a>
        </li>
        <li class="nav-item" >
          <span class="nav-link"  :class="isSushi && 'nav-link-sushi montserrat-700'"  @click="signOut">
            {{ $t("message.logOut") }}
          </span>
        </li>
      </ul>
      <ul class="nav flex-column clearfix" :class="isSushi && 'align-items-center justify-content-center text-white' " v-else-if="viewConfig.LogIn" >
        <li class="nav-item">
          <a class="nav-link  active" :class="isSushi && 'nav-link-sushi montserrat-700'" @click="openLogin(true)">
            {{ $t("message.login") }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link "  :class="isSushi && 'nav-link-sushi montserrat-700'" @click="openLogin(false)">
            {{ $t("message.register") }}
          </a>
        </li>
        <li class="nav-item">
          <a v-if="!isSushi" class="nav-link theme-link"   href="#" @click="goToMainPage">
            {{ capitalizeFirstLetter($t("message.stores")) }}
          </a>

          <a v-else class="nav-link theme-link nav-link-sushi montserrat-700 " href="https://www.sushihub.com.au/our-products/" >
            {{ capitalizeFirstLetter($t("message.ourProducts")) }}
          </a>
        </li>



          <li class="nav-item" v-if="isSushi">
            <a class="nav-link theme-link nav-link-sushi montserrat-700"   href="https://www.sushihub.com.au/about-us/ " >
              {{ capitalizeFirstLetter($t("message.aboutUs")) }}
            </a>
          </li>

        <li class="nav-item" v-if="isSushi">
          <a class="nav-link theme-link nav-link-sushi montserrat-700"  href=" https://www.sushihub.com.au/hub-events/ ">
            {{ capitalizeFirstLetter($t("message.hubEvents")) }}
          </a>
        </li>

          <li class="nav-item" v-if="isSushi">
            <a class="nav-link theme-link nav-link-sushi montserrat-700"  href=" https://www.sushihub.com.au/hub-news/ ">
              {{ capitalizeFirstLetter($t("message.hubNews")) }}
            </a>
          </li>

          <li class="nav-item" v-if="isSushi">
            <a class="nav-link theme-link nav-link-sushi montserrat-700"   href=" https://www.sushihub.com.au/contact-us/ " >
              {{ capitalizeFirstLetter($t("message.contactUs")) }}
            </a>
          </li>

      </ul>
    </div>
  </div>

<!--</div>-->
</template>


<style scoped>

.nav-link-sushi {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {capitalizeFirstLetter} from '../../filters/capitalizeFirstLetter';

export default {
  name: "Drawer",

  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isSushi : {
      type : Boolean
    }
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "viewConfig",
      "mobileStyles",
      "currentStoreDoc",
      "useStampCollection",
      "getFirstValidRedemptionRule",
      "applicableLoyalityRule",
      "getMenuEntity",
    ]),
    showLoyaltyOption() {
      return this.applicableLoyalityRule.length > 0 &&
        (this.getFirstValidRedemptionRule !== null ||
        this.getMenuEntity.PointsToDollarRatio > 0);
    },


  },

  watch: {
    // whenever question changes, this function will run
    isActive(oldActive) {
      if (oldActive) {
        document.body.classList.add("position-fixed");

      }else {
        document.body.classList.remove("position-fixed");
      }
    }

  },

  mounted() {
    const that = this;
    if (this.$refs.backDiv) {
      this.$refs.backDiv.onclick = function() {
        if (that.isActive) {
          that.$emit("closed");
        }
      };
    }
  },


  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setShowOverlay"]),
    capitalizeFirstLetter,
    signOut() {
      this.logout();
      this.navigateShoppingcart();
      this.isSushi && this.$emit("overlay", false);
    },
    navigateShoppingcart() {
      if (window.location.pathname.indexOf("giftcards") != -1)
        this.$router.push("/store/" + this.currentStoreDoc.Name + "/giftcards");
      else this.$router.push("/store/" + this.currentStoreDoc.Name);
    },
    getStyle() {
      var styles = [];
      if(this.isSushi){

        styles.push(this.mobileStyles.primaryColourSushiImportant);
        styles.push({width : '100%', marginTop: this.storeRoute() ?  '4.2rem' : '2.5rem'})
        return styles;
      }
      styles.push(this.mobileStyles.primaryColourImportant);
      styles.push(this.mobileStyles.nav);
      return styles;
    },
    goToMainPage() {
      if(this.$route.name === 'mainpage') {
        this.$emit('closed');
       this.isSushi && this.$emit("overlay", false);
      } else {
        this.$router.push({name: 'mainpage'});
      }
    },
    openLogin(login) {
      this.$emit("closed");
      this.isSushi &&   this.$emit("overlay", true);
      this.setShowOverlay({value: true, login: login});
    },
    storeRoute(){
      const path = this.$router.currentRoute.path
      const pathAddress = path.toString()
      return pathAddress.includes("/store")
    }
  },
};
</script>
